<template>
    <div class="main-nav grid" :class="[bemFacet]" v-if="showPartial">
        <button type="button" class="u-reset main-nav--mobile-backdrop"
                v-if="facet === 'mobile'"
                aria-hidden="true"
                @click="onRequestCloseMobileNavigation">
        </button>

        <div class="main-nav--list">
            <ul class="u-reset main-nav--items" :class="itemsClasses">
                <li v-for="(entry, entryIdx) in partial.content.menu" :key="entryIdx"
                        class="main-nav--item">
                    <router-link class="u-reset main-nav--link"
                            ref="entries"
                            :exact-active-class="bemAdd('is-active-exact', 'link')"
                            :active-class="bemAdd('is-active', 'link')"
                            :to="entry.path">
                        <span class="main-nav--link-label" v-text="entry.label"></span>
                    </router-link>
                </li>
            </ul>
        </div>

        <div class="main-nav--wave" v-if="hasRail && isMounted" :style="railStyles"></div>

        <!-- <pre v-text="partial"></pre> -->
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import isMountedMixin from 'framework/mixins/is-mounted';
    import bemMixin from 'framework/mixins/bem';
    import cmsPartialMixin from 'framework/mixins/cms/cms-partial';

    export default {
        mixins: [
            bemMixin('main-nav'),
            isMountedMixin,
            cmsPartialMixin,
        ],
        props: {
            hasRail: {
                type: Boolean,
                default: false,
            },
            partialName: {
                type: String,
                default: 'menu',
            },
        },
        data() {
            return {
                railStyles: {},
            };
        },
        computed: {
            ...mapGetters(['scroll', 'viewport']),
            itemsClasses() {
                return [
                    this.facet === 'mobile' ? 'grid--container' : '',
                ];
            },
            activeIdx() {
                if (!this.isMounted) {
                    return -1;
                }

                return this.partial.content.menu.findIndex(entry => {
                    return this.$router.resolve(entry.path).route.fullPath === this.$route.fullPath;
                });
            },
        },
        methods: {
            ...mapActions(['setMobileNavigation']),
            onRequestCloseMobileNavigation() {
                this.setMobileNavigation({ isOpen: false });
            },
        },
        watch: {
            activeIdx: {
                handler() {
                    const hasEntries = Array.isArray(this.$refs.entries);

                    if (!~this.activeIdx || !this.isMounted || !hasEntries || this.viewport.width == null) {
                        return;
                    }
                    /* eslint-disable */

                    const $activeRef = this.$refs.entries[this.activeIdx].$el;
                    const { innerWidth } = window;
                    const { right, left, width } = $activeRef.getBoundingClientRect();

                    this.railStyles = {
                        width: `${ width }px`,
                        //transform: `translateX(${ transform }px)`,
                        transform: `translateX(${ right - innerWidth + this.scroll.scrollbarWidth }px)`,
                        //backgroundPositionX: `${ transform - offsetWidth }px`,
                        backgroundPositionX: `${ (innerWidth - right + width) }px`,
                    };
                },
                immediate: true,
            },
        },
    };
</script>



// WEBPACK FOOTER //
// vehi-industriepfad/assets/src/js/app/framework/components/main-nav/index.vue?a559fb9a